// src/store/useUserAddressStore.js
import { create } from "zustand";
import { persist } from "zustand/middleware";

// same encode/decode pattern you use in checkout store
function encode(value) {
  return btoa(unescape(encodeURIComponent(JSON.stringify(value))));
}
function decode(value) {
  return JSON.parse(decodeURIComponent(escape(atob(value))));
}

const initialState = {
  street: "",
  houseNumber: "",
  city: "",
  postalCode: "",
  coords: null,            // { lat: number, lng: number }
  full: "",                // e.g. "Dunikowskiego 141, 44-100 Gliwice, Poland"
  short: "",               // e.g. "Dunikowskiego 141"
  deliveryOk: null,        // null | true | false (result of last radius check)
  lastCheckedShopId: null, // optional: which shop this address was validated against
};

const useUserAddressStore = create(
  persist(
    (set, get) => ({
      ...initialState,

      // Set entire structured object at once
      setStructuredAddress: (addr) =>
        set({
          street: addr.street || "",
          houseNumber: addr.houseNumber || "",
          city: addr.city || "",
          postalCode: addr.postalCode || "",
          coords: addr.coords || null,
          full: addr.full || "",
          short: addr.short || `${addr.street || ""} ${addr.houseNumber || ""}`.trim(),
        }),

      // Field setters (handy for step-by-step flows)
      setStreet: (street) => set({ street }),
      setHouseNumber: (houseNumber) => set({ houseNumber }),
      setCity: (city) => set({ city }),
      setPostalCode: (postalCode) => set({ postalCode }),
      setCoords: (coords) => set({ coords }),

      // Validation flags
      markDeliveryOk: (ok, shopId = null) =>
        set({ deliveryOk: !!ok, lastCheckedShopId: shopId }),

      // Reset everything
      clearAddress: () => set({ ...initialState }),

      // Convenience: get a minimal snapshot (no functions)
      getSnapshot: () => {
        const s = get();
        const {
          street, houseNumber, city, postalCode,
          coords, full, short, deliveryOk, lastCheckedShopId
        } = s;
        return { street, houseNumber, city, postalCode, coords, full, short, deliveryOk, lastCheckedShopId };
      },
    }),
    {
      name: "user-address-storage",
      serialize: (state) => encode(state),
      deserialize: (str) => decode(str),
      version: 1,
    }
  )
);

export default useUserAddressStore;
